import Axios from 'axios'
import React, { Component } from 'react'
import ReadAxios from '../axiosComponent/read'

export default class cityNameRenderer extends Component {

    state = {
        cityNames: []
    }

    componentDidMount() {
        console.log("Princess here", this.props);
        ReadAxios({
            url: `cityMaster/${this.props.data.city_id}`,
        }).then((res) => {
            console.log("princess 2 :", res)
            if (res.status === 200) {
                let name = res.data.resultSet[0] ? res.data.resultSet[0]['cityName'] : ""
                this.setState({
                    cityNames: name
                })
            }
        })
    }


    render() {
        return (
            <div>
                {/* {this.state.cityNames.length > 0 ? 
                this.state.cityNames.map((o,i)=>(
                    <>{o}</>
                )):''} */}
                {console.log("princess final:", this.state.cityNames)}
                {this.state.cityNames}
            </div>
        )
    }
}
